import React, { Component } from 'react';

import { AISShipTypeAhead } from './../filter-components/AISShipTypeAhead/AISShipTypeAhead';
import { FilterToFromTime } from './FilterToFromTime';
import PropTypes from 'prop-types';
import { TimeUtils } from '../chart-components/ChartUtils/TimeUtils';

export class FilterTrackShips extends Component {
  static propTypes = {
    setFilter: PropTypes.func.isRequired,
    filter: PropTypes.object
  };

  static defaultProps = {
    filter: {}
  };

  constructor (props) {
    super(props);
    this.state = {
      filter: props.filter
    };
    this.update = this.update.bind(this);
  }

  update (key, val) {
    const { filter, setFilter } = this.props;
    filter[key] = val;
    if (filter.fromTime && !filter.toTime) {
      let toTime = new Date(filter.fromTime);
      toTime.setDate(toTime.getDate() + 1);
      filter.toTime = toTime;
    } else if (!filter.fromTime && filter.toTime) {
      filter.toTime = undefined;
    }
    setFilter({ 'mmsi': filter.mmsi });
  }

  render () {
    const { filter, setFilter } = this.props;

    return (
      <div key='fromTime'>
        <FilterToFromTime key='flt1' firstYear={2013} filter={filter} setFilter={setFilter} />
        <AISShipTypeAhead
          key='flt2'
          label='Velg skip (tidsrom må velges først)'
          isMulti
          getTimeFilters={() => {
            if (filter.fromTime && filter.toTime) {
              return {
                StartTime: TimeUtils.toCompactDate(new Date(filter.fromTime)),
                EndTime: TimeUtils.toCompactDate(new Date(filter.toTime))
              };
            }
          }}
          setValue={d => {
            var mmsis = d
              .map(el => {
                return el.value;
              })
              .join(',');
            this.update('mmsi', mmsis);
          }}
        />
      </div>
    );
  }
}
